import React from "react";
import { ToastContainer } from "react-toastify";
import "../../assets/styles/main.scss";
import { DashboardAlertWidget } from "../DashboardAlertWidget/DashboardAlertWidget";
import { CedarShellLayout } from "./CedarShell/CedarShellLayout";

interface Props {
  children: JSX.Element;
  hasFilter: boolean;
  extraClass?: string;
}

export const IframeLayout = (props: Props): JSX.Element => {
  const { children, hasFilter, extraClass } = props;

  return (
    <CedarShellLayout>
      <div className={`pageWrapper ${extraClass}`} id={"mainDashboard"}>
        {/* --menu_width zeroed out: that column was reserved for the old DashboardMenu, now
            replaced by CedarShellLayout's own sidenav. */}
        <div
          className={`dashboard hide_on_mobile ${hasFilter ? "" : "noPageFilter"} iframe_dashboard`}
          id="iframeDashboard"
          style={{ "--menu_width": "0" } as React.CSSProperties}
        >
          <DashboardAlertWidget />
          {children}
        </div>
        <ToastContainer
          position="top-right"
          autoClose={2500}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick={true}
          draggable={false}
          pauseOnHover={false}
        />
      </div>
    </CedarShellLayout>
  );
};
